;(function($) {
    'use strict'

    $(document).on('click', 'a[href$="#newsletter"]', function(e){
        e.preventDefault();

        $('.newsletter-modal').modal({
            clickClose: false,
            showClose: false,
            fadeDuration: 125
        });

        $('.newsletter-modal').on($.modal.BEFORE_OPEN, function(event, modal){
            $(modal.$blocker).css({"overflow": "hidden", "z-index": "99"});
        });
        $('.newsletter-modal').on($.modal.BEFORE_CLOSE, function(event, modal){
            modal.$blocker.css({"overflow": "auto", "z-index": "1"});
        });


        return false
    });
})(jQuery)
